import { Spin } from 'antd';

const FullLoader = () => {
  return (
    <div className="flex items-center justify-center h-full">
      <Spin size="large" className="scale-150 " />
    </div>
  );
};

export default FullLoader;
